import { render, staticRenderFns } from "./warehouse-province.vue?vue&type=template&id=5859a9b4"
import script from "./warehouse-province.vue?vue&type=script&lang=js"
export * from "./warehouse-province.vue?vue&type=script&lang=js"
import style0 from "./warehouse-province.vue?vue&type=style&index=0&id=5859a9b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports